"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.documentFactory = void 0;
var utils_1 = require("@lglp/utils");
var constants_1 = require("../../constants");
var fields_1 = require("../../fields");
var entity_factory_1 = require("../entity-factory");
var processDocument = function (prismicDoc, normalizedDoc, logger) {
    var _a, _b, _c;
    var createdAt = logger.required(fields_1.toTimestamp(((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.publication_date) || prismicDoc.first_publication_date));
    var updatedAt = logger.required(fields_1.toTimestamp(((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.modified_date) || prismicDoc.last_publication_date));
    return utils_1.compact(__assign(__assign({}, normalizedDoc), { uid: logger.required(fields_1.toText(prismicDoc.uid) || constants_1.toDocumentType(prismicDoc.type, logger)), type: logger.required(constants_1.toDocumentType(prismicDoc.type, logger)), createdAt: createdAt, updatedAt: updatedAt && createdAt && updatedAt > createdAt ? updatedAt : undefined, alternateLanguages: (_c = prismicDoc.alternate_languages) === null || _c === void 0 ? void 0 : _c.map(function (prismicDocument) { return fields_1.toDocumentLink(prismicDocument, logger); }).filter(Boolean) }));
};
var documentFactory = function (type, next) {
    return entity_factory_1.entityFactory(type, function (prismicDoc, normalizedDoc, logger) {
        var normalizedDocument = processDocument(prismicDoc, normalizedDoc, logger);
        return next(prismicDoc, normalizedDocument, logger);
    });
};
exports.documentFactory = documentFactory;
//# sourceMappingURL=document-factory.js.map